var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMediumLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82942 9.68531C5.84575 9.523 5.82387 9.35912 5.76553 9.20677C5.70718 9.05443 5.61399 8.91786 5.49341 8.80798L3.00275 5.78531V5.33331H10.7334L16.7094 18.54L21.9627 5.33331H29.3334V5.78531L27.2041 7.83998C27.1139 7.90964 27.0442 8.0025 27.0027 8.10865C26.9611 8.21479 26.9491 8.33024 26.9681 8.44265V23.5546C26.9491 23.6671 26.9611 23.7825 27.0027 23.8886C27.0442 23.9948 27.1139 24.0877 27.2041 24.1573L29.2841 26.2133V26.6666H18.8254V26.2146L20.9801 24.108C21.1921 23.8946 21.1921 23.832 21.1921 23.5066V11.2906L15.2027 26.616H14.3947L7.42141 11.2906V21.5626C7.36408 21.9933 7.50675 22.4293 7.80808 22.7413L10.6094 26.1653V26.616H2.66675V26.1653L5.46675 22.7413C5.6149 22.5867 5.72485 22.3996 5.78782 22.195C5.85079 21.9903 5.86503 21.7738 5.82942 21.5626V9.68531Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMediumLink);
export default __webpack_public_path__ + "static/media/icon_medium-link.e679a0bf3e286641bcafe1cafea7d3e9.svg";
export { ForwardRef as ReactComponent };